"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _v = _interopRequireDefault(require("uuid/v4"));

var _date = _interopRequireDefault(require("@spothero/utils/date"));

var _time = _interopRequireDefault(require("@spothero/utils/time"));

var _DateTimePicker = _interopRequireDefault(require("./DateTimePicker"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var TOOLTIP_TYPES = ['date', 'time', 'none'];

var DateTimeRangePicker =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(DateTimeRangePicker, _Component);

  function DateTimeRangePicker(props) {
    var _this;

    (0, _classCallCheck2.default)(this, DateTimeRangePicker);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DateTimeRangePicker).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onStartChange", function (_ref) {
      var selectedDate = _ref.selectedDate,
          selectedTime = _ref.selectedTime;
      var onStartChange = _this.props.onStartChange;
      var _this$state = _this.state,
          endDate = _this$state.endDate,
          endTime = _this$state.endTime;
      var newData = {
        startDate: selectedDate,
        startTime: selectedTime,
        endDate: endDate,
        endTime: endTime
      };

      _this.setState((0, _objectSpread2.default)({
        startDate: selectedDate,
        startTime: selectedTime
      }, _this._getDisableEndTimeBefore(newData)));

      if (onStartChange) {
        onStartChange(newData);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onEndChange", function (_ref2) {
      var selectedDate = _ref2.selectedDate,
          selectedTime = _ref2.selectedTime;
      var onEndChange = _this.props.onEndChange;
      var _this$state2 = _this.state,
          startDate = _this$state2.startDate,
          startTime = _this$state2.startTime;
      var newData = {
        startDate: startDate,
        startTime: startTime,
        endDate: selectedDate,
        endTime: selectedTime
      };

      _this.setState((0, _objectSpread2.default)({
        endDate: selectedDate,
        endTime: selectedTime
      }, _this._getDisableEndTimeBefore(newData)));

      if (onEndChange) {
        onEndChange(newData);
      }
    });
    var startId = props.startId,
        endId = props.endId,
        _startDate = props.startDate,
        _startTime = props.startTime,
        _endDate = props.endDate,
        _endTime = props.endTime,
        disableEndTimeBefore = props.disableEndTimeBefore,
        startTooltipType = props.startTooltipType,
        startTooltipMessage = props.startTooltipMessage,
        endTooltipType = props.endTooltipType,
        endTooltipMessage = props.endTooltipMessage,
        tooltipPosition = props.tooltipPosition,
        updateTooltipPositionOnMove = props.updateTooltipPositionOnMove;

    if (!startId || !endId) {
      throw new Error("The props 'startId' and 'endId' are required to make DateTimeRangePicker accessible for users using assistive technologies such as screen readers. Check the render method of DateTimeRangePicker.");
    }

    if (startTooltipType || startTooltipMessage || endTooltipType || endTooltipMessage || tooltipPosition || updateTooltipPositionOnMove) {
      throw new Error('Tooltip support inside of DateTimePicker was removed in v6.0.0. Use dateNode and timeNode getters in a parent component to add tooltips manually as necessary.');
    }

    _this.state = {
      startDate: _startDate,
      startTime: _startTime,
      endDate: _endDate,
      endTime: _endTime,
      disableEndTimeBefore: disableEndTimeBefore,
      addErrorClass: false,
      addHighlightClass: false,
      endKey: (0, _v.default)()
    };
    return _this;
  }

  (0, _createClass2.default)(DateTimeRangePicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._checkInitialTimeDisabling();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _this$props = this.props,
          onValid = _this$props.onValid,
          onInvalid = _this$props.onInvalid;
      var _this$state3 = this.state,
          startDate = _this$state3.startDate,
          startTime = _this$state3.startTime,
          endDate = _this$state3.endDate,
          endTime = _this$state3.endTime,
          addHighlightClass = _this$state3.addHighlightClass;
      var prevStartDate = prevState.startDate,
          prevStartTime = prevState.startTime,
          prevEndDate = prevState.endDate,
          prevEndTime = prevState.endTime;
      var startMoment = startDate && startTime ? this._getCombinedDate(startDate, startTime) : null;
      var endMoment = endDate && endTime ? this._getCombinedDate(endDate, endTime) : null;
      var validationState = {
        startDate: startDate,
        startTime: startTime,
        endDate: endDate,
        endTime: endTime,
        startMoment: startMoment,
        endMoment: endMoment,
        isEndDayBeforeStartDay: startMoment && endMoment && endMoment.isBefore(startMoment, 'day'),
        isEndTimeSameOrBeforeStartTime: startMoment && endMoment && endMoment.isSameOrBefore(startMoment, 'hour')
      };
      var isValid = true;

      if (addHighlightClass) {
        // if the previous state of the component included the highlight class remove it here
        // so that next time it needs to highlight it can be re-added and the animation plays
        this._clearHighlightTimeout();

        this._removeHighlightTimeout = setTimeout(function () {
          _this2.setState({
            addHighlightClass: false
          });
        }, 3000);
      }

      if (startDate && startTime && endDate && endTime) {
        if (startDate !== prevStartDate || startTime !== prevStartTime || endDate !== prevEndDate || endTime !== prevEndTime) {
          isValid = this._checkValidity();
        }
      }

      if (!isValid && onInvalid) {
        onInvalid(validationState);
      } else if (isValid && onValid) {
        onValid(validationState);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._clearHighlightTimeout();
    }
  }, {
    key: "_checkInitialTimeDisabling",
    value: function _checkInitialTimeDisabling() {
      var _this$state4 = this.state,
          startDate = _this$state4.startDate,
          startTime = _this$state4.startTime,
          endDate = _this$state4.endDate,
          endTime = _this$state4.endTime;

      var _this$_getDisableEndT = this._getDisableEndTimeBefore({
        startDate: startDate,
        startTime: startTime,
        endDate: endDate,
        endTime: endTime
      }),
          disableEndTimeBefore = _this$_getDisableEndT.disableEndTimeBefore,
          endKey = _this$_getDisableEndT.endKey;

      this.setState({
        disableEndTimeBefore: disableEndTimeBefore,
        endKey: endKey
      });
    }
  }, {
    key: "_clearHighlightTimeout",
    value: function _clearHighlightTimeout() {
      if (this._removeHighlightTimeout) {
        clearTimeout(this._removeHighlightTimeout);
      }
    }
  }, {
    key: "_getCombinedDate",
    value: function _getCombinedDate(date, time) {
      return _date.default.combineDateAndTime(_date.default.getAsMoment(date), _time.default.getAsMoment(time));
    }
  }, {
    key: "_checkValidity",
    value: function _checkValidity() {
      var _this$props2 = this.props,
          autoBumpInvalidEnabled = _this$props2.autoBumpInvalidEnabled,
          endTimeBump = _this$props2.endTimeBump,
          onEndChange = _this$props2.onEndChange;
      var _this$state5 = this.state,
          startDate = _this$state5.startDate,
          startTime = _this$state5.startTime,
          endDate = _this$state5.endDate,
          endTime = _this$state5.endTime;

      var start = this._getCombinedDate(startDate, startTime);

      var end = this._getCombinedDate(endDate, endTime);

      var newState = {
        addErrorClass: false,
        endDate: endDate,
        endTime: endTime
      };
      var isValid = true;

      if (end.isSameOrBefore(start)) {
        isValid = false;

        if (autoBumpInvalidEnabled) {
          isValid = true;
          var newEnd = start.clone().add(endTimeBump, 'minutes');
          newState.endDate = newEnd.format('MM/DD/YYYY');
          newState.endTime = newEnd.format('hh:mm A');
          newState.addHighlightClass = true;
          newState.endKey = (0, _v.default)(); // check what times should be disabled based on newly selected values

          var _this$_getDisableEndT2 = this._getDisableEndTimeBefore({
            startDate: startDate,
            startTime: startTime,
            endDate: newState.endDate,
            endTime: newState.endTime
          }),
              disableEndTimeBefore = _this$_getDisableEndT2.disableEndTimeBefore,
              newEndTime = _this$_getDisableEndT2.endTime;

          newState.disableEndTimeBefore = disableEndTimeBefore;

          if (newEndTime) {
            newState.endTime = newEndTime;
          }
        } else {
          newState.addErrorClass = true;
        }
      }

      this.setState(newState);

      if (onEndChange) {
        onEndChange({
          startDate: startDate,
          startTime: startTime,
          endDate: newState.endDate,
          endTime: newState.endTime
        });
      }

      return isValid;
    }
  }, {
    key: "_getDisableEndTimeBefore",
    value: function _getDisableEndTimeBefore(_ref3) {
      var startDate = _ref3.startDate,
          startTime = _ref3.startTime,
          endDate = _ref3.endDate,
          endTime = _ref3.endTime;
      var _this$props3 = this.props,
          timeStep = _this$props3.timeStep,
          endTimeBump = _this$props3.endTimeBump,
          autoBumpInvalidEnabled = _this$props3.autoBumpInvalidEnabled,
          propDisableEndTimeBefore = _this$props3.disableEndTimeBefore;
      var _this$state6 = this.state,
          disableEndTimeBefore = _this$state6.disableEndTimeBefore,
          endKey = _this$state6.endKey;
      var newState = {
        disableEndTimeBefore: disableEndTimeBefore,
        endKey: endKey
      };

      if (startDate && startTime && endDate && endTime) {
        var start = this._getCombinedDate(startDate, startTime);

        var end = this._getCombinedDate(endDate, endTime);

        if (start.isSame(end, 'day')) {
          newState.disableEndTimeBefore = start.clone().add(timeStep, 'minutes').format('hh:mm A');
          newState.endKey = (0, _v.default)();

          if (start.isSameOrAfter(end, 'hour') && autoBumpInvalidEnabled) {
            // bump the end time because it will get bumped anyway due to the prior time not being in the list anymore
            newState.endTime = start.clone().add(endTimeBump, 'minutes').format('hh:mm A');
            newState.addHighlightClass = true;
          }
        } else if (newState.disableEndTimeBefore !== propDisableEndTimeBefore) {
          newState.disableEndTimeBefore = propDisableEndTimeBefore;
          newState.endKey = (0, _v.default)();
        }
      }

      return newState;
    }
    /**
     * Getter for the start date time picker.
     *
     * @public
     * @returns {Element} - The component reference.
     */

  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props4 = this.props,
          className = _this$props4.className,
          startId = _this$props4.startId,
          endId = _this$props4.endId,
          useIcons = _this$props4.useIcons,
          startDateLabel = _this$props4.startDateLabel,
          startTimeLabel = _this$props4.startTimeLabel,
          endDateLabel = _this$props4.endDateLabel,
          endTimeLabel = _this$props4.endTimeLabel,
          startDateName = _this$props4.startDateName,
          startTimeName = _this$props4.startTimeName,
          endDateName = _this$props4.endDateName,
          endTimeName = _this$props4.endTimeName,
          timeStep = _this$props4.timeStep,
          disableStartPast = _this$props4.disableStartPast,
          disableStartDateBefore = _this$props4.disableStartDateBefore,
          disableStartDateAfter = _this$props4.disableStartDateAfter,
          disableStartTimeBefore = _this$props4.disableStartTimeBefore,
          disableStartTimeAfter = _this$props4.disableStartTimeAfter,
          disableEndPast = _this$props4.disableEndPast,
          disableEndDateBefore = _this$props4.disableEndDateBefore,
          disableEndDateAfter = _this$props4.disableEndDateAfter,
          disableEndTimeAfter = _this$props4.disableEndTimeAfter,
          areAllFieldsEmpty = _this$props4.areAllFieldsEmpty,
          useTetherShim = _this$props4.useTetherShim;
      var _this$state7 = this.state,
          startDate = _this$state7.startDate,
          startTime = _this$state7.startTime,
          endDate = _this$state7.endDate,
          endTime = _this$state7.endTime,
          addErrorClass = _this$state7.addErrorClass,
          disableEndTimeBefore = _this$state7.disableEndTimeBefore,
          endKey = _this$state7.endKey,
          addHighlightClass = _this$state7.addHighlightClass;
      var classes = (0, _classnames.default)('DateTimeRangePicker', className);
      var startClasses = (0, _classnames.default)('DateTimePicker-start', {
        'DateTimePicker-error': areAllFieldsEmpty
      });
      var endClasses = (0, _classnames.default)('DateTimePicker-end', {
        'DateTimePicker-highlight': addHighlightClass
      }, {
        'DateTimePicker-error': addErrorClass || areAllFieldsEmpty
      });
      var newDisableEndDateBefore = startDate ? startDate : disableEndDateBefore;
      var overrideInitialEndMonthWithSelected = true; // if the end picker has a date disabled whose month is after the end selected date, make sure the calendar starts with the first selectable month

      if (endDate && newDisableEndDateBefore) {
        var endMoment = _date.default.getAsMoment(endDate);

        var endBeforeMoment = _date.default.getAsMoment(newDisableEndDateBefore);

        overrideInitialEndMonthWithSelected = endMoment.isAfter(endBeforeMoment);
      }

      return _react.default.createElement("div", {
        className: classes
      }, _react.default.createElement(_DateTimePicker.default, {
        ref: function ref(node) {
          _this3._startDateTime = node;
        },
        id: startId,
        dateName: startDateName,
        timeName: startTimeName,
        className: startClasses,
        calendarClassName: "calendar-start",
        useIcons: useIcons,
        dateLabel: startDateLabel,
        timeLabel: startTimeLabel,
        timeStep: timeStep,
        selectedDate: startDate,
        selectedTime: startTime,
        onChange: this._onStartChange,
        disablePast: disableStartPast,
        disableDateBefore: disableStartDateBefore,
        disableDateAfter: disableStartDateAfter,
        disableTimeBefore: disableStartTimeBefore,
        disableTimeAfter: disableStartTimeAfter,
        useTetherShim: useTetherShim,
        datePlaceholder: "Start Date",
        timePlaceholder: "Start Time"
      }), _react.default.createElement(_DateTimePicker.default, {
        key: endKey,
        ref: function ref(node) {
          _this3._endDateTime = node;
        },
        id: endId,
        dateName: endDateName,
        timeName: endTimeName,
        className: endClasses,
        calendarClassName: "calendar-end",
        useIcons: useIcons,
        dateLabel: endDateLabel,
        timeLabel: endTimeLabel,
        timeStep: timeStep,
        selectedDate: endDate,
        selectedTime: endTime,
        overrideInitialMonthWithSelected: overrideInitialEndMonthWithSelected,
        onChange: this._onEndChange,
        disablePast: disableEndPast,
        disableDateBefore: newDisableEndDateBefore,
        disableDateAfter: disableEndDateAfter,
        disableTimeBefore: disableEndTimeBefore,
        disableTimeAfter: disableEndTimeAfter,
        useTetherShim: useTetherShim,
        datePlaceholder: "End Date",
        timePlaceholder: "End Time"
      }));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: "startDateTime",
    get: function get() {
      return this._startDateTime;
    }
    /**
     * Getter for the end date time picker.
     *
     * @public
     * @returns {Element} - The component reference.
     */

  }, {
    key: "endDateTime",
    get: function get() {
      return this._endDateTime;
    }
  }]);
  return DateTimeRangePicker;
}(_react.Component);

exports.default = DateTimeRangePicker;
(0, _defineProperty2.default)(DateTimeRangePicker, "propTypes", {
  /** Additional class(es) to add to the component. */
  className: _propTypes.default.string,

  /** A unique ID which is used to identify the start picker for accessibility purposes on the client as well as the server. */
  startId: _propTypes.default.string.isRequired,

  /** A unique ID which is used to identify the end picker for accessibility purposes on the client as well as the server. */
  endId: _propTypes.default.string.isRequired,

  /** Whether to show the calendar and clock icons in the selectors. */
  useIcons: _propTypes.default.bool,

  /** A custom label (typically a Label component) to display above the start date input. */
  startDateLabel: _propTypes.default.node,

  /** A custom label (typically a Label component) to display above the start time selector. */
  startTimeLabel: _propTypes.default.node,

  /** A custom label (typically a Label component) to display above the end date input. */
  endDateLabel: _propTypes.default.node,

  /** A custom label (typically a Label component) to display above the end time selector. */
  endTimeLabel: _propTypes.default.node,

  /** A unique name which is used to identify the start date element. If belonging to a form this is used as the key for serialization and is required. */
  startDateName: _propTypes.default.string,

  /** A unique name which is used to identify the start time element. If belonging to a form this is used as the key for serialization and is required. */
  startTimeName: _propTypes.default.string,

  /** A unique name which is used to identify the end date element. If belonging to a form this is used as the key for serialization and is required. */
  endDateName: _propTypes.default.string,

  /** A unique name which is used to identify the end time element. If belonging to a form this is used as the key for serialization and is required. */
  endTimeName: _propTypes.default.string,

  /** The multiplier with which to create selectable times in the dropdown (in minutes). */
  timeStep: _propTypes.default.number,

  /** The amount of time (in minutes) the end time should bump up when the start date is after end date. Usually set to the same as timeStep. */
  endTimeBump: _propTypes.default.number,

  /** A string in the format 'MM/DD/YYYY' representing the start date which should be selected. */
  startDate: _propTypes.default.string,

  /** A string in the format of 'hh:mm A' representing the start time which should be selected. */
  startTime: _propTypes.default.string,

  /** A string in the format 'MM/DD/YYYY' representing the end date which should be selected. */
  endDate: _propTypes.default.string,

  /** A string in the format of 'hh:mm A' representing the end time which should be selected. */
  endTime: _propTypes.default.string,

  /**
   * Function to execute when the selected start date and/or start time changes.
   *
   * @param {String} startDate - The start date in the format 'MM/DD/YYYY'.
   * @param {String} startTime - The start time in the format 'hh:mm A'.
   * @param {String} endDate - The end date in the format 'MM/DD/YYYY'.
   * @param {String} endTime - The end time in the format 'hh:mm A'.
   */
  onStartChange: _propTypes.default.func,

  /**
   * Function to execute when the selected end date and/or end time changes.
   *
   * @param {String} startDate - The start date in the format 'MM/DD/YYYY'.
   * @param {String} startTime - The start time in the format 'hh:mm A'.
   * @param {String} endDate - The end date in the format 'MM/DD/YYYY'.
   * @param {String} endTime - The end time in the format 'hh:mm A'.
   */
  onEndChange: _propTypes.default.func,

  /**
   * Where the applicable start tooltip should be anchored to.
   *
   * @deprecated Tooltip support was removed in v6.0.0.
   */
  startTooltipType: _propTypes.default.oneOf(TOOLTIP_TYPES),

  /**
   * Where the applicable end tooltip should be anchored to.
   *
   * @deprecated Tooltip support was removed in v6.0.0.
   */
  endTooltipType: _propTypes.default.oneOf(TOOLTIP_TYPES),

  /**
   * The message to display inside of the start tooltip.
   *
   * @deprecated Tooltip support was removed in v6.0.0.
   */
  startTooltipMessage: _propTypes.default.string,

  /**
   * The message to display inside of the end tooltip.
   *
   * @deprecated Tooltip support was removed in v6.0.0.
   */
  endTooltipMessage: _propTypes.default.string,

  /**
   * Where to position the tooltip in relation to the triggering element.
   *
   * @deprecated Tooltip support was removed in v6.0.0.
   */
  tooltipPosition: _propTypes.default.oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * Whether to reposition the tooltip when it moves, be it via window resize or scrolling or whatever moves it.
   *
   * @deprecated Tooltip support was removed in v6.0.0.
   */
  updateTooltipPositionOnMove: _propTypes.default.bool,

  /** Whether to disable days before today in the start date selector. */
  disableStartPast: _propTypes.default.bool,

  /** A string in the format 'MM/DD/YYYY' representing the date where days before it should be disabled in the start calendar. */
  disableStartDateBefore: _propTypes.default.string,

  /** A string in the format 'MM/DD/YYYY' representing the date where days after it should be disabled in the start calendar. */
  disableStartDateAfter: _propTypes.default.string,

  /** A string in the format 'hh:mm A' representing the time where times before it should be disabled in the start selector. */
  disableStartTimeBefore: _propTypes.default.string,

  /** A string in the format 'hh:mm A' representing the time where times after it should be disabled in the start selector. */
  disableStartTimeAfter: _propTypes.default.string,

  /** Whether to disable days before today in the end date selector. */
  disableEndPast: _propTypes.default.bool,

  /** A string in the format 'MM/DD/YYYY' representing the date where days before it should be disabled in the end calendar. */
  disableEndDateBefore: _propTypes.default.string,

  /** A string in the format 'MM/DD/YYYY' representing the date where days after it should be disabled in the end calendar. */
  disableEndDateAfter: _propTypes.default.string,

  /** A string in the format 'hh:mm A' representing the time where times before it should be disabled in the end selector. */
  disableEndTimeBefore: _propTypes.default.string,

  /** A string in the format 'hh:mm A' representing the time where times after it should be disabled in the end selector. */
  disableEndTimeAfter: _propTypes.default.string,

  /** Enables automatically bumping the end date/time to be the start date/time plus `endTimeBump`. If false, the fields will be marked invalid. */
  autoBumpInvalidEnabled: _propTypes.default.bool,

  /** Puts the calendar in the center of the page with a shim behind it. */
  useTetherShim: _propTypes.default.bool,

  /** Forces highlighting all the fields in the red error state. */
  areAllFieldsEmpty: _propTypes.default.bool,

  /**
   * Function to execute when the selected date(s) are valid.
   */
  onValid: _propTypes.default.func,

  /**
   * Function to execute when the selected date(s) are invalid.
   */
  onInvalid: _propTypes.default.func
});
(0, _defineProperty2.default)(DateTimeRangePicker, "defaultProps", {
  useIcons: true,
  timeStep: 30,
  endTimeBump: 30,
  disableStartPast: true,
  disableEndPast: true
});
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(TOOLTIP_TYPES, "TOOLTIP_TYPES", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/DateTime/DateTimeRangePicker.jsx");
  reactHotLoader.register(DateTimeRangePicker, "DateTimeRangePicker", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/DateTime/DateTimeRangePicker.jsx");
  leaveModule(module);
})();

;